/* @flow */

export type SerializedObject = Object;

export function serializeObject(val : Object) : SerializedObject {
    return val;
}

export function deserializeObject(val : SerializedObject) : Object {
    return val;
}
